export enum B2C_BALANCE_ELIGIBILITY {
    LOW_BALANCE = "LOW_BALANCE",
    UNLIMITED = "UNLIMITED",
}

export interface B2cHalfCardConfigField {
    label: string;
    id: string;
    type: "DropDown" | "Input" | "FreeText" | "MultiSuggestiveTyping";
    options?: string[];
    required: boolean;
    value: string;
    enabled: boolean;
    apiCall?: string;
}

export interface B2cHalfCardConfig {
    title: string;
    fields: B2cHalfCardConfigField[];
    showConsent?: string;
}

export interface BillToCompanyWidgetData {
    title: string;
    enabled: boolean;
    balance?: number;
    icon: string;
    balanceEligibility?: B2C_BALANCE_ELIGIBILITY;
    disableMessage?: string;
    showExpenseCodeHalfCard?: boolean;
    b2cHalfCardConfig?: B2cHalfCardConfig;
}
